import { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themedColor,setThemedColor] = useState(() => {
    const themeData = JSON.parse(localStorage.getItem("theme"));
    const themeKey = themeData?.title || "Light";

    const themes = {
      Light: {
        background2: "#70CEEA",
        background: "#1c2b40",
        hover: "#4a90e226",
        sidebar:"#1c2b40"
      },
      Dark: {
        background2: "#95a5a6",
        background: "#424242",
        hover: "#767a88",
        sidebar:"#181818"
      }
    };

    return themes[themeKey] || themes.Light;
  });

  const updateTheme =() =>{
  const themeData = JSON.parse(localStorage.getItem("theme"));
    const themeKey = themeData?.title || "Light";

    const themes = {
      Light: {
        background2: "#70CEEA",
        background: "#1c2b40",
        hover: "#4a90e226",
        sidebar:"#1c2b40"
      },
      Dark: {
        background2: "#95a5a6",
        background: "#424242",
        hover: "#767a88",
        sidebar:"#181818"
      }
    };

    setThemedColor(themes[themeKey] || themes.Light);
  }

return (
    <ThemeContext.Provider value={{ themedColor ,updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
